import { cn } from '@/lib/cn';

/** CForm の `Input` / `CFormTextItem` と同じ既定幅（px） */
export const CFORM_DEFAULT_COMBOBOX_TRIGGER_WIDTH_PX = 180;
export type ComboboxTriggerWidth = number | string | undefined;
export type ResolvedComboboxTriggerWidth = {
  numericWidth: number | null;
  widthClassName: string | undefined;
  shellClassName: string;
  shellStyle: {
    width: number;
  } | undefined;
  contentClassName: string;
  contentStyle: {
    width: number;
  } | undefined;
};

/**
 * Combobox トリガーと PopoverContent の幅を揃える。
 * `ControlledSelect` / `InstallableSoftwareSelect` と同じ契約。
 */
export function resolveComboboxTriggerWidth(width: ComboboxTriggerWidth = CFORM_DEFAULT_COMBOBOX_TRIGGER_WIDTH_PX): ResolvedComboboxTriggerWidth {
  const numericWidth = typeof width === 'number' ? width : null;
  const widthClassName = typeof width === 'string' ? width : undefined;
  return {
    numericWidth,
    widthClassName,
    shellClassName: cn('relative inline-block min-w-0', widthClassName),
    shellStyle: numericWidth != null ? {
      width: numericWidth
    } : undefined,
    contentClassName: cn('max-h-96 w-full overflow-hidden p-0', widthClassName),
    contentStyle: numericWidth != null ? {
      width: numericWidth
    } : undefined
  };
}